import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import PropertyPageWidget from './propertyPageWidget'
function Property() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m9'>
                   <PropertyPageWidget/>
            </div>
        </div>
    </div>
  )
}

export default Property